import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { GALLERY } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-white px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="mb-14 md:mb-20">
            <p className="mb-6 text-[0.7rem] uppercase tracking-[0.3em] text-sage">
              Gallery
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
              A glimpse <span className="italic text-forest">inside</span>
            </h2>
          </div>
        </Reveal>

        <div className="columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <button
                type="button"
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(src)}
                className="group block w-full overflow-hidden rounded-2xl"
              >
                <img
                  src={src}
                  alt={`Nur Therapy gallery ${i + 1}`}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/90 p-6 backdrop-blur-sm"
          >
            <button
              type="button"
              data-testid="gallery-close"
              onClick={() => setActive(null)}
              className="absolute right-6 top-6 text-cream/80 transition-colors hover:text-cream"
              aria-label="Close"
            >
              <X size={32} />
            </button>
            <motion.img
              src={active}
              alt="Nur Therapy gallery"
              initial={{ scale: 0.92 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.92 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain shadow-2xl"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
